<div class="flex flex-col gap-6 lg:flex-row lg:gap-10">
  <aside class="w-full shrink-0 lg:w-60">
    <h1
      class="pb-4 font-brand text-3xl font-normal tracking-tight text-zinc-50">
      {{ 'menu.settings' | transloco }}
    </h1>
    <!-- nav px-3 + item px-3: -ml-6 lines the item content up with the
         heading, so the hover/active pill hangs out to the left only;
         -mr-3 cancels the nav padding so the pill ends at the column edge -->
    <vx-sidebar-nav class="-ml-6 -mr-3">
      @for (group of groups(); track group.label) {
        <vx-sidebar-nav-group [label]="group.label | transloco">
          @for (item of group.items; track item.label) {
            <vx-sidebar-nav-item
              [link]="item.routerLink"
              [icon]="$any(item.icon)"
              [indicator]="false">
              {{ item.label | transloco }}
            </vx-sidebar-nav-item>
          }
        </vx-sidebar-nav-group>
      }
    </vx-sidebar-nav>
  </aside>

  <main class="min-w-0 flex-1 pb-10">
    <router-outlet></router-outlet>
  </main>
</div>
